package tta.destinigo.talktoastro.bottom_navigation

import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Home
import androidx.compose.material.icons.filled.School
import androidx.compose.material.icons.outlined.AddCircle
import androidx.compose.material.icons.outlined.Favorite
import androidx.compose.material.icons.outlined.MoreHoriz
import androidx.compose.ui.graphics.vector.ImageVector

// Define Bottom Navigation Items with appropriate Material 3 Extended Icons
enum class BottomTab(val title: String, val icon: ImageVector) {
    HOME("Home", Icons.Filled.Home),
    COURSES("Courses", Icons.Filled.School),
    POST("Post", Icons.Outlined.AddCircle),
    FAVORITE("Favorite", Icons.Outlined.Favorite),
    MORE("More", Icons.Outlined.MoreHoriz)
}